import { type AnyAction } from 'redux';
import actions from './actions';
import { type ITagsState } from '@/types/tags';

export const initialState: ITagsState = {
  activeTagIds: null,
};

export const tags = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case actions.SET_ACTIVE_TAG:
      return Object.assign({}, state, {
        activeTagIds: [action.id],
      });

    case actions.TOGGLE_ACTIVE_TAG: {
      const toggledId = Number(action.id);
      const current = state.activeTagIds ?? [];
      const next = current.includes(toggledId)
        ? current.filter((id) => id !== toggledId)
        : [...current, toggledId];

      // An empty selection is stored as null, the same as no filter at all.
      return Object.assign({}, state, {
        activeTagIds: next.length ? next : null,
      });
    }

    case actions.CLEAR_ACTIVE_TAGS:
      return Object.assign({}, state, {
        activeTagIds: null,
      });

    default:
      return state;
  }
};
